import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=d95537be&scoped=true&"
import script from "./AdminStatistics.vue?vue&type=script&lang=js&"
export * from "./AdminStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatistics.vue?vue&type=style&index=0&id=d95537be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95537be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VCol,VIcon,VLayout,VRow})
